<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '275px' }"
>
    <ng-template pTemplate="header">Register Product</ng-template>
    <form [formGroup]="RegistrationForm">
        <label for="float-dd" class="required">Product Code</label>
        <div style="margin-bottom: 1em">
            <input
                pInputText
                class="w-full"
                type="text"
                id="product-code"
                placeholder="Product Code"
                formControlName="ProductCode"
                onfocus="this.select();"
            />
        </div>
        <label for="float-dd" class="required">Company ID</label>
        <div style="margin-bottom: 1em">
            <input
                pInputText
                class="w-full"
                type="text"
                id="company-id"
                placeholder="Company ID"
                formControlName="CustomerId"
                onfocus="this.select();"
            />
        </div>
        <label for="float-dd" class="required">EIN</label>
        <div style="margin-bottom: 1em">
            <input
                pInputText
                class="w-full"
                type="text"
                id="ein"
                placeholder="EIN"
                formControlName="EIN"
                onfocus="this.select();"
            />
        </div>
    </form>
    <ng-template #footer >
        <button
            pButton
            label="Submit"
            icon="pi pi-check"
            class="p-button-text p-button-success"
            [disabled]="RegistrationForm.invalid"
            (click)="onSubmit(RegistrationForm.value)"
        ></button>
    </ng-template>
</p-dialog>
